import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const slides = [
  {
    id: 1,
    hasTitle: true,
    text: 'Это не обучение. Это настройка внутренней чистоты.\n\nЗдесь не нужно раздумывать, задаваться вопросами и прорабатывать негатив. Нужно просто внимательно (не механически) выполнять предложенные действия.',
  },
  {
    id: 2,
    text: 'Твой главный враг - суета.\n\nЕсли в течение дня ты чувствуешь, что закипаешь или теряешь фокус - жми кнопку RESET в правом верхнем углу экрана.\n\nЭто твоя точка возврата в центр.',
  },
  {
    id: 3,
    isStart: true,
  },
];

const Onboarding = ({ onComplete }) => {
  const [currentSlide, setCurrentSlide] = useState(0);

  const handleNext = () => {
    if (currentSlide < slides.length - 1) {
      setCurrentSlide(prev => prev + 1);
    }
  };

  const handleStart = () => {
    onComplete();
  };

  const slide = slides[currentSlide];

  return (
    <div style={styles.container}>
      <AnimatePresence mode="wait">
        <motion.div
          key={slide.id}
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -20 }}
          transition={{ duration: 0.5 }}
          style={styles.slideContent}
        >
          {!slide.isStart ? (
            <>
              {slide.hasTitle && (
                <motion.h1
                  initial={{ opacity: 0, y: -10 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ delay: 0.2, duration: 0.5 }}
                  style={styles.appTitle}
                >
                  НАСТРОЙКА НА ЯСНОСТЬ
                </motion.h1>
              )}
              
              <div style={styles.icon}>✧</div>
              
              <p style={styles.text}>
                {slide.text.split('\n').map((line, i) => (
                  <React.Fragment key={i}>
                    {line}
                    <br />
                  </React.Fragment>
                ))}
              </p>
              
              <button style={styles.nextButton} onClick={handleNext}>
                ДАЛЕЕ
              </button>
            </>
          ) : (
            <>
              <div style={styles.icon}>◇</div>
              <p style={styles.readyText}>
                7 дней практики.
                <br />
                Простые действия.
                <br />
                Реальные изменения.
              </p>
              <button style={styles.startButton} onClick={handleStart}>
                НАЧАТЬ
              </button>
              <p style={styles.progressNote}>
                Заходи всегда с одного и того же устройства и браузера, так твой прогресс сохраняется автоматически.
                </p>
            </>
          )}
        </motion.div>
      </AnimatePresence>

      <div style={styles.dots}>
        {slides.map((_, index) => (
          <div
            key={index}
            style={{
              ...styles.dot,
              ...(index === currentSlide ? styles.dotActive : {}),
            }}
          />
        ))}
      </div>
    </div>
  );
};

const styles = {
  container: {
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '40px 24px',
    background: 'linear-gradient(135deg, #0a0a0a 0%, #1a1a1a 50%, #0d0d0d 100%)',
  },
  slideContent: {
    maxWidth: '340px',
    textAlign: 'center',
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
  appTitle: {
    color: '#E5D2A0',
    fontSize: '14px',
    fontWeight: '600',
    letterSpacing: '4px',
    marginBottom: '40px',
    textTransform: 'uppercase',
  },
  icon: {
    fontSize: '40px',
    color: '#E5D2A0',
    marginBottom: '32px',
  },
  text: {
    color: 'rgba(255, 255, 255, 0.9)',
    fontSize: '17px',
    lineHeight: '1.8',
    marginBottom: '40px',
  },
  nextButton: {
    padding: '16px 48px',
    background: 'transparent',
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: '#E5D2A0',
    borderRadius: '30px',
    color: '#E5D2A0',
    fontSize: '14px',
    fontWeight: '600',
    letterSpacing: '3px',
    cursor: 'pointer',
  },
  readyText: {
    color: 'rgba(255, 255, 255, 0.7)',
    fontSize: '16px',
    lineHeight: '1.8',
    marginBottom: '40px',
  },
  startButton: {
    padding: '18px 64px',
    background: '#E5D2A0',
    border: 'none',
    borderRadius: '30px',
    color: '#0a0a0a',
    fontSize: '16px',
    fontWeight: '700',
    letterSpacing: '3px',
    cursor: 'pointer',
  },
  progressNote: {
    color: 'rgba(255, 255, 255, 0.4)',
    fontSize: '13px',
    lineHeight: '1.6',
    marginTop: '24px',
  },
  dots: {
    display: 'flex',
    gap: '12px',
    paddingBottom: '40px',
  },
  dot: {
    width: '8px',
    height: '8px',
    borderRadius: '50%',
    background: 'rgba(229, 210, 160, 0.3)',
    transition: 'all 0.3s ease',
  },
  dotActive: {
    background: '#E5D2A0',
    transform: 'scale(1.2)',
  },
};

export default Onboarding;